import { useState, useEffect } from "react";
// utils
import { getStorageItem, setStorageItem } from "src/utils/storage-available";

// ----------------------------------------------------------------------

export function useLocalStorage(key, defaultValue) {
  const [value, setValue] = useState(() => getStorageItem(key, defaultValue));

  useEffect(() => {
    const listener = e => {
      if (e.storageArea === localStorage && e.key === key) {
        setValue(getStorageItem(key, defaultValue));
      }
    };
    window.addEventListener("storage", listener);

    return () => {
      window.removeEventListener("storage", listener);
    };
  }, [key, defaultValue]);

  const setValueInLocalStorage = newValue => {
    setValue(currentValue => {
      const result = typeof newValue === "function" ? newValue(currentValue) : newValue;

      setStorageItem(key, result);

      return result;
    });
  };

  return [value, setValueInLocalStorage];
}
